var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditReview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0796 5.91413L11.6491 16.3629C10.6105 17.4033 7.52721 17.8853 6.83841 17.1953C6.14961 16.5052 6.61974 13.4166 7.65842 12.3761L18.0999 1.91639C18.3573 1.63498 18.669 1.40876 19.0163 1.25137C19.3634 1.09398 19.7389 1.00866 20.1199 1.00063C20.5008 0.992597 20.8796 1.06197 21.233 1.20458C21.5865 1.3472 21.9075 1.56012 22.1766 1.83043C22.4457 2.10074 22.6573 2.42285 22.7987 2.77734C22.9401 3.13185 23.0084 3.51136 22.9993 3.893C22.9903 4.27464 22.904 4.65052 22.746 4.99789C22.5879 5.34525 22.3613 5.65695 22.0796 5.91413Z",
    stroke: "#2C2C2C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8401 3.28564H5.37337C4.21347 3.28564 3.10116 3.74721 2.28099 4.56882C1.46083 5.39043 1 6.50476 1 7.66669V18.6193C1 19.7812 1.46083 20.8956 2.28099 21.7171C3.10116 22.5388 4.21347 23.0003 5.37337 23.0003H17.4001C19.8164 23.0003 20.6801 21.0289 20.6801 18.6193V13.143",
    stroke: "#2C2C2C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditReview);
export default __webpack_public_path__ + "static/media/edit_review.93fb05ee8100edb02be555dbbd4b41a6.svg";
export { ForwardRef as ReactComponent };